import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { commonPageFieldList, commonPageFieldListSuccess, getpdfReportdata, GetVenderSupplierCustomer, GetVenderSupplierCustomerSuccess } from "../../../store/actions";
import * as pageId from "../../../routes/allPageID"
import * as url from "../../../routes/route_url";
import * as _cfunc from "../../../components/Common/CommonFunction";
import CommonPurchaseList from "../../../components/Common/CommonPurchaseList";
import { C_Button, Go_Button, PageLoadingSpinner } from "../../../components/Common/CommonButton";
import { Col, FormGroup, Label, Row } from "reactstrap";
import { C_DatePicker } from "../../../CustomValidateForm";
import * as _act from "../../../store/Inventory/StockEntryRedux/action";
import WastageEntryMaster from "./WastageEntryMaster";
import {
    deleteWastageId, deleteWastageIdSuccess, editWastageList, updateWastageListSuccess,
    wastageFilter, wastageFilterSuccess, wastageExcelReport,
    wastageExcelReportSuccess,
} from "../../../store/Inventory/WastageEntryMasterRedux/action";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { WastageSingleGetAPI, WastageExcelAPI } from "../../../helpers/backend_helper";
import { ExcelReportComponent } from "../../../components/Common/ReportCommonFunc/ExcelDownloadWithCSS";
import { customAlert } from "../../../CustomAlert/ConfirmDialog";
import { alertMessages } from "../../../components/Common/CommonErrorMsg/alertMsg";
import * as report from "../../../Reports/ReportIndex";
import C_Report from "../../../components/Common/C_Report";
import Select from "react-select";


const WastageList = () => {

    const dispatch = useDispatch();
    const history = useHistory()
    const currentDate_ymd = _cfunc.date_ymd_func();
    const [headerFilters, setHeaderFilters] = useState('');

    const reducers = useSelector(
        (state) => ({
            tableList: state.wastageReducer.filterList,
            goBtnLoading: state.wastageReducer.loading,
            deleteMsg: state.wastageReducer.deleteMsg,
            userAccess: state.Login.RoleAccessUpdateData,
            pageField: state.CommonPageFieldReducer.pageFieldList,
            editData: state.wastageReducer.editData,
            updateMsg: state.wastageReducer.updateMsg,
            listBtnLoading: (state.PdfReportReducers.listBtnLoading || state.wastageReducer.listBtnLoading || state.wastageReducer.loading || state.PdfReportReducers.ReportBtnLoading),
            excelData: state.wastageReducer.excelData,
            excelBtnLoading: state.wastageReducer.excelBtnLoading,
            pdfBtnLoading: state.PdfReportReducers.ReportBtnLoading === "wastagePrint",
            pdfdata: state.PdfReportReducers.pdfdata,
            Distributor: state.CommonPartyDropdownReducer.commonPartyDropdownOption,
        })
    );
    const { commonPartyDropSelect } = useSelector((state) => state.CommonPartyDropdownReducer);
    const { pageField, goBtnLoading, excelBtnLoading, pdfBtnLoading, pdfdata, Distributor, listBtnLoading } = reducers

    const { fromdate = currentDate_ymd, todate = currentDate_ymd } = headerFilters;
    const [btnMode, setBtnMode] = useState("");
    // const IsMannagementParty = !_cfunc.loginUserIsFranchisesRole() && _cfunc.loginIsSCMParty() && _cfunc.loginUserAdminRole();
    const IsMannagementParty = _cfunc.isAdminDivisionRole();
    const [PartyDropdown, setPartyDropdown] = useState({ value: 0, label: " All" });
    const Party_Option = Distributor.map(i => ({ value: i.id, label: i.Name }));
    Party_Option.unshift({ value: 0, label: " All" });

    const partyOnchange = (e) => {
        setPartyDropdown(e);
    };
    const action = {
        getList: wastageFilter,
        editId: editWastageList,
        deleteId: deleteWastageId,
        updateSucc: updateWastageListSuccess,
        deleteSucc: deleteWastageIdSuccess,
    };

    useEffect(() => {
        dispatch(GetVenderSupplierCustomerSuccess([]));
        dispatch(GetVenderSupplierCustomer({ subPageMode: url.WASTAGE_LIST, PartyID: _cfunc.loginSelectedPartyID() }));
        return () => {
            dispatch(GetVenderSupplierCustomerSuccess([]));
        }
    }, []);

    useEffect(() => {
        const page_Id = pageId.WASTAGE_LIST;
        dispatch(commonPageFieldList(page_Id));
        return () => {
            dispatch(commonPageFieldListSuccess(null));
        }
    }, []);

    useEffect(() => {
        if (commonPartyDropSelect.value > 0) {
            goButtonHandler();
        } else {
            dispatch(wastageFilterSuccess([]));
        }
    }, [commonPartyDropSelect]);

    useEffect(() => {
        try {
            const excelResp = reducers.excelData;
            if (excelResp?.Status === true && excelResp?.StatusCode === 200 && Array.isArray(excelResp.Data) && excelResp.Data.length > 0) {

                // ⭐ Built from pageField.PageFieldList (10 fields) instead of pageField
                // itself — ExcelFunctions.js only ever reads PageFieldMaster (5 fields)
                // when pageField is passed directly, so we translate PageFieldList into
                // the customKeyColumns shape ourselves, here on the page.
                const excelColumns = (pageField?.PageFieldList || [])
                    .slice()
                    .sort((a, b) => (a.DisplayIndex ?? 0) - (b.DisplayIndex ?? 0))
                    .map((field) => ({
                        dataField: field.ControlID,
                        text: field.FieldLabel,
                        controlTypeName: field.ControlTypeName,
                    }));

                ExcelReportComponent({
                    // pageField intentionally NOT passed — see note above
                    excelTableData: excelResp.Data,
                    excelFileName: "Wastage Report",
                    customKeyColumns: {
                        isButton: false,
                        tableData: excelColumns,
                    },
                });
                dispatch(wastageExcelReportSuccess({ Data: [] }));
            } else if (excelResp?.StatusCode === 204) {
                customAlert({ Type: 3, Message: alertMessages.recordNotAvailable });
            }
        } catch (e) { }
    }, [reducers.excelData]);

    useEffect(() => {
        try {
            if (btnMode === "print") {
                if ((pdfdata.Status === true) && (pdfdata.StatusCode === 204)) {
                    customAlert({ Type: 3, Message: alertMessages.recordNotAvailable });
                    return;
                }
            }
        } catch (e) { }
    }, [pdfdata]);

    // 🔥 SHARED — single source of truth for the report payload, used by
    // Go / Excel / Print alike, so they can never drift apart in shape.
    function buildReportPayload() {
        return {
            FromDate: fromdate,
            ToDate: todate,
            PartyID: IsMannagementParty ? PartyDropdown.value : _cfunc.loginSelectedPartyID(),
            EmployeeID: _cfunc.loginEmployeeID()
        };
    }

    const goButtonHandler = () => {
        dispatch(wastageFilter(buildReportPayload()));
    };

    function excelBtnHandler() {
        const config = { jsonBody: JSON.stringify(buildReportPayload()) }
        dispatch(wastageExcelReport(config));
    }

    function printBtnHandler() {
        setBtnMode("print");
        sessionStorage.setItem("WastageReportDateRange", JSON.stringify({ fromDate: fromdate, toDate: todate })); // ⭐ read by WastageReport1, same pattern as Scheme
        const config = {
            ReportType: report.wastage,
            jsonBody: JSON.stringify(buildReportPayload()),
            btnId: "wastagePrint",
        };
        dispatch(getpdfReportdata(WastageExcelAPI, config));
    }
    function fromdateOnchange(e, date) {
        let newObj = { ...headerFilters }
        newObj.fromdate = date
        setHeaderFilters(newObj)
    }

    function todateOnchange(e, date) {
        let newObj = { ...headerFilters }
        newObj.todate = date
        setHeaderFilters(newObj)
    }

    function downBtnFunc(config) {
        const id = config?.rowData?.id;
        if (!id) return;
        config["ReportType"] = "wastage1";
        config["jsonBody"] = {
            WastageIDs: id.toString()
        };
        dispatch(
            getpdfReportdata(
                WastageSingleGetAPI,
                config
            )
        );
    }

    return (
        <React.Fragment>
            <PageLoadingSpinner isLoading={(goBtnLoading || !pageField)} />
            <div className="page-content">
                <div className="px-3 c_card_filter header text-black mb-1">
                    <Row className="align-items-center">
                        <Col sm={2} className="mt-1 mb-1">
                            <FormGroup className="row mt-2">
                                <Label className="col-sm-4 p-2" style={{ width: "83px" }}>From Date</Label>
                                <Col sm="8">
                                    <C_DatePicker
                                        options={{ altInput: true, altFormat: "d-m-Y", dateFormat: "Y-m-d" }}
                                        name='Date'
                                        value={fromdate}
                                        onChange={fromdateOnchange}
                                    />
                                </Col>
                            </FormGroup>
                        </Col>

                        <Col sm={2} className="mt-1 mb-1">
                            <FormGroup className="row mt-2">
                                <Label className="col-sm-4 p-2" style={{ width: "65px" }}>To Date</Label>
                                <Col sm="8">
                                    <C_DatePicker
                                        options={{ altInput: true, altFormat: "d-m-Y", dateFormat: "Y-m-d" }}
                                        name='Date'
                                        value={todate}
                                        onChange={todateOnchange}
                                    />
                                </Col>
                            </FormGroup>
                        </Col>

                        {IsMannagementParty && (
                            <Col sm={3} className="mt-1 mb-1">
                                <FormGroup className="row mt-2">
                                    <Label className="col-sm-4 p-2" style={{ width: "65px", marginRight: "20px" }}>Party</Label>
                                    <Col sm="8">
                                        <Select
                                            name="Party"
                                            value={PartyDropdown}
                                            isSearchable={true}
                                            className="react-dropdown"
                                            classNamePrefix="dropdown"
                                            styles={{ menu: provided => ({ ...provided, zIndex: 2 }) }}
                                            options={Party_Option}
                                            onChange={(e) => { partyOnchange(e) }}
                                        />
                                    </Col>
                                </FormGroup>
                            </Col>
                        )}

                        <Col sm="auto" className="mt-1 mb-1 d-flex align-items-center justify-content-end ms-auto" style={{ gap: "8px" }}>
                            <Go_Button
                                loading={goBtnLoading}
                                onClick={(e) => goButtonHandler()}
                            />
                            <C_Button
                                type="button"
                                spinnerColor="white"
                                loading={pdfBtnLoading}
                                className="btn btn-info"
                                onClick={() => printBtnHandler()}
                            >
                                Print
                            </C_Button>

                            <C_Button
                                type="button"
                                spinnerColor="white"
                                loading={excelBtnLoading}
                                className="btn btn-primary"
                                onClick={() => excelBtnHandler()}
                            >
                                Excel
                            </C_Button>

                        </Col>
                    </Row>
                </div>

                {pageField && (
                    <div className="mt-n1">
                        <CommonPurchaseList
                            action={action}
                            reducers={reducers}
                            pageMode={url.WASTAGE_LIST}
                            showBreadcrumb={false}
                            MasterModal={WastageEntryMaster}
                            masterPath={url.WASTAGE_ENTRY_MASTER}
                            newBtnPath={url.WASTAGE_ENTRY_MASTER}
                            ButtonMsgLable={"Wastage Master"}
                            deleteName={"WastagefullNumber"}
                            goButnFunc={goButtonHandler}
                            downBtnFunc={downBtnFunc}
                            totalAmountShow={true}
                        />
                    </div>
                )}
            </div>
            
        </React.Fragment>
    )
}

export default WastageList;